import React from "react";
import { useQuery } from "seed/gql";
import { Formik, Form, Field } from "formik";
import l from "components/util/l";

// The form every brief screen publishes a revision through. Owners are dropped from the
// notification list because they are notified by the backend regardless of what is picked
// here, and offering them would read as if unchecking them meant something.
const RevisionForm = ({
  flow,
  title,
  initialValues = {},
  onSubmit,
  onDelete,
  showProposalFields = false,
  referenceOptions = [],
}) => {

  const reqParticipants = useQuery(`{
    participants {
      isOwner
      user {
        email
        firstName
        lastName
      }
    }
  }`, `flow.id=${flow.id}`);

  const participants = (reqParticipants.data?.participants || [])
    .filter((participant) => !participant.isOwner);

  const options = participants.map((participant) => ({
    label: `${participant.user?.firstName} ${participant.user?.lastName} (${participant.user?.email})`,
    value: participant.user?.email,
  }));

  const formInitialValues = {
    name: initialValues.name || "",
    description: initialValues.description || "",
    type: initialValues.type || "major",
    reference: initialValues.reference || "",
    notification_emails: initialValues.notification_emails || [],
    notification_message: initialValues.notification_message || "",
  };

  return (
    <div className="card border-0 shadow-none">
      <div className="card-header bg-white border-bottom px-4 py-3">
        <h3 className="card-header-title mb-0">{l(title)}</h3>
      </div>
      <div className="card-body px-4 py-4">
        <Formik
          initialValues={formInitialValues}
          onSubmit={onSubmit}
        >
          {({ values, setFieldValue }) => (
            <Form>

              <div className="form-group mb-4">
                <label className="input-label pb-1" htmlFor="name">
                  {l("Nombre%PA490")} <span className="text-danger">*</span>
                </label>
                <Field
                  id="name"
                  name="name"
                  type="text"
                  autoComplete="off"
                  className="form-control"
                  maxLength="512"
                  required
                  autoFocus
                />
              </div>

              <div className="form-group mb-4">
                <label className="input-label pb-1" htmlFor="description">
                  {l("Descripción%PA508")}
                </label>
                <Field
                  as="textarea"
                  id="description"
                  name="description"
                  className="form-control"
                  rows="4"
                />
              </div>

              {showProposalFields && (
                <>
                  <div className="form-group mb-4">
                    <label className="input-label pb-1" htmlFor="type">
                      Tipo de propuesta
                    </label>
                    <Field as="select" id="type" name="type" className="form-control">
                      <option value="major">Principal</option>
                      <option value="complementary">Complementaria</option>
                      <option value="revision">Revisión</option>
                    </Field>
                  </div>

                  {values.type === "revision" && (
                    <div className="form-group mb-4">
                      <label className="input-label pb-1" htmlFor="reference">
                        Propuesta de referencia
                      </label>
                      <Field as="select" id="reference" name="reference" className="form-control">
                        <option value="">Selecciona una propuesta</option>
                        {referenceOptions.map((option) => (
                          <option key={`proposal-reference-${option.value}`} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </Field>
                    </div>
                  )}
                </>
              )}

              <div className="form-group mb-4">
                <label className="input-label pb-1" htmlFor="notification_message">
                  {l("Mensaje de notificación%PA551")}
                </label>
                <Field
                  as="textarea"
                  id="notification_message"
                  name="notification_message"
                  className="form-control"
                  rows="3"
                />
              </div>

              <div className="form-group mb-4">
                <label className="input-label pb-1 d-block" htmlFor="notification_emails">
                  {l("Notificar a%PA550")}
                </label>
                <div id="notification_emails">
                  {options.length === 0 && <div className="text-muted small"> - </div>}
                  {options.map((option) => {
                    const isChecked = values.notification_emails.includes(option.value);
                    return (
                      <div className="custom-control custom-checkbox mb-2" key={option.value}>
                        <input
                          id={`notification-email-${option.value}`}
                          type="checkbox"
                          className="custom-control-input"
                          checked={isChecked}
                          onChange={(event) => {
                            if (event.target.checked) {
                              setFieldValue("notification_emails", [
                                ...values.notification_emails,
                                option.value,
                              ]);
                              return;
                            }

                            setFieldValue(
                              "notification_emails",
                              values.notification_emails.filter((email) => email !== option.value)
                            );
                          }}
                        />
                        <label className="custom-control-label" htmlFor={`notification-email-${option.value}`}>
                          {option.label}
                        </label>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="d-flex w-100">
                {onDelete && (
                  <button
                    type="button"
                    className="btn btn-outline-danger px-3 mr-2"
                    onClick={onDelete}
                  >
                    {l("Eliminar%GA001")}
                  </button>
                )}

                <button
                  type="submit"
                  className="btn btn-primary btn-block"
                >
                  {l("Guardar cambios%PA455")}
                </button>
              </div>

            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default RevisionForm;